import { AddLineInput, RemoveLineInput } from "../../utils/cart/cartLineTypes";
import {
  addItemAction,
  editItemAction,
  editLineQuantityAction,
  removeItemAction,
  resetCartAction,
} from "../redux/slices/cartLoyaltyV2Slice";
import { useAppDispatch } from "./useReduxHooks";

type EditTarget =
  | { lineId: string; input: AddLineInput }
  | { itemIndex: number; input: AddLineInput };

export function useCartMutations() {
  const dispatch = useAppDispatch();

  return {
    addItem: (input: AddLineInput) => dispatch(addItemAction(input)),

    editItem: (target: EditTarget) => {
      dispatch(
        editItemAction(
          "lineId" in target
            ? { lineId: target.lineId, ...target.input }
            : { itemIndex: target.itemIndex, ...target.input }
        )
      );
    },

    removeItem: (target: RemoveLineInput) => dispatch(removeItemAction(target)),

    editLineQuantity: (target: { lineId: string; quantity: number }) =>
      dispatch(editLineQuantityAction(target)),

    resetCart: () => dispatch(resetCartAction()),
  };
}
